<template>
<el-table
  ref="table"
  row-key="id"
  :data="dataTree"
  :tree-props="{children:'children'}"
  height="100%"
  border
  header-row-class-name="custom-table-header"
  class="custom-table no-inner-border audit-table"
  style="width: 100%"
  @select="onDataSelect"
  @select-all="onAllDataSelect"
>
  <el-table-column
    type="selection"
    width="38"
    fixed
  />

  <el-table-column prop="name" label="因子" fixed width="200" />

  <el-table-column label="自动审核" align="center">
    <el-table-column
      v-for="auditRuleCategory in auditRuleCategories"
      :key="auditRuleCategory.id"
      :prop="auditRuleCategory.id"
      width="130"
      align="center"
    >
      <template slot="header" slot-scope="scope">
        <el-checkbox
          v-model="auditRuleCategoryIds"
          :label="auditRuleCategory.id"
          @change="onFilterAuditRuleCategoryIdsChanged"
        >{{auditRuleCategory.name}}</el-checkbox>
      </template>

      <template slot-scope="{row}">
        <span class="exception" :value="row.flagMap[auditRuleCategory.id]" @click="onAutoCellNumClick(row, auditRuleCategory.id)">{{row.flagMap[auditRuleCategory.id]}}</span>
      </template>
    </el-table-column>
  </el-table-column>

  <el-table-column label="人工审核" align="center">
    <el-table-column
      v-for="manualOperatorType in manualOperatorTypes"
      :key="manualOperatorType.id"
      :prop="manualOperatorType.id"
      width="130"
      align="center"
    >
      <template slot="header" slot-scope="scope">
        <el-checkbox
          v-model="auditRuleCategoryIds"
          :label="manualOperatorType.id"
          @change="onFilterAuditRuleCategoryIdsChanged"
        >手工{{manualOperatorType.name}}</el-checkbox>
      </template>

      <template slot-scope="{row}">
        <span :class="manualOperatorType.id" :value="row.flagMap[manualOperatorType.id]" @click="onManualCellNumClick(row, manualOperatorType.id)">{{row.flagMap[manualOperatorType.id]}}</span>
      </template>
    </el-table-column>
  </el-table-column>
</el-table>
</template>

<script>
import BaseStore from '../../../components/BaseStore'

import manualOperatorTypes from './manualOperatorTypes'
import {AUDIT_DATA_LIST_CHANGED, AUDIT_MAIN_GRID_FACTOR_IDS_CHANGED} from './EventKeys'
import unitConverter from '../../../utils/unitConverter'

export default {
  name: 'AuditMainGrid',
  extends: BaseStore,
  props: {
    auditRuleCategories: {
      required: true,
      type: Array
    },
    dataList: {
      required: true,
      type: Array
    },
    noDataRecords: {
      required: true,
      type: Array
    },
    causeOptions: {
      required: true,
      type: Array
    },
    defaultUnitProp: {
      type: String,
      default: 'displayUnit'
    }
  },
  data () {
    return {
      auditRuleCategoryIds: [],
      unitProp: this.defaultUnitProp
    }
  },
  computed: {
    manualOperatorTypes: () => manualOperatorTypes,
    auditCategories () {
      return [...this.auditRuleCategories, ...this.manualOperatorTypes]
    },
    auditRuleCategoryMap () {
      return this.auditCategories.reduce((map, auditRuleCategory) => {
        return auditRuleCategory.flags.reduce((map, flag) => {
          map[flag] = auditRuleCategory.id
          return map
        }, map)
      }, {})
    },
    causeOptionMap () {
      return this.causeOptions.reduce((map, causeOption) => {
        map[causeOption.value] = causeOption.label
        return map
      }, {})
    },
    noDataRecordMap () {
      return this.noDataRecords.reduce((map, noDataRecord) => {
        map[noDataRecord.dataTime] = noDataRecord.cause
        return map
      }, {})
    },
    formatDataList () {
      let {dataList, auditCategories, auditRuleCategoryMap} = this
      return dataList.map(data => ({
        id: data.id,
        name: data.name,
        parentId: data.parentId,
        flagMap: data.data.reduce((map, value) => {
          let {auditFlag} = value
          if (value.id === null) {
            map.NULL++
          } else {
            let {autoFlag} = value
            let autoFlags = autoFlag ? autoFlag.split('|') : []

            autoFlags.forEach(autoFlag => {
              let auditRuleCategoryId = auditRuleCategoryMap[autoFlag]

              if (auditRuleCategoryId) {
                map[auditRuleCategoryId]++
              }
            })
          }

          let operatorCategoryId = auditRuleCategoryMap[auditFlag]

          if (operatorCategoryId) {
            map[operatorCategoryId]++
          }

          return map
        }, auditCategories.reduce((map, auditRuleCategory) => {
          map[auditRuleCategory.id] = 0
          return map
        }, {}))
      }))
    },
    filterList () {
      let {formatDataList, auditRuleCategoryIds} = this
      let filterList = [...formatDataList]

      if (auditRuleCategoryIds.length > 0) {
        filterList = filterList.filter(({flagMap}) => auditRuleCategoryIds.some(auditRuleCategoryId => flagMap[auditRuleCategoryId] > 0))
      }

      let factorCategoryIds = new Set(filterList.map(({parentId}) => parentId))

      if (factorCategoryIds.size > 1) {
        let factorGroupMap = JSON.parse(JSON.stringify(this.factorGroupMap))
        let {auditCategories} = this
        let roots = []
        let tmpList = [...filterList]

        for (let i = 0; i < tmpList.length; i++) {
          let data = tmpList[i]
          let {parentId} = data
          let parent = factorGroupMap[parentId]

          if (parent) {
            let {children} = parent

            if (!Array.isArray(children)) {
              children = parent.children = []
              parent.flagMap = auditCategories.reduce((map, auditRuleCategory) => {
                map[auditRuleCategory.id] = 0
                return map
              }, {})

              tmpList.push(parent)
            }

            let dataFlagMap = data.flagMap
            let parentFlagMap = parent.flagMap

            for (let key in dataFlagMap) {
              parentFlagMap[key] += dataFlagMap[key]
            }

            children.push(data)
          } else {
            roots.push(data)
          }
        }

        if (roots.length === 1) {
          roots = roots[0].children
          tmpList.splice(tmpList.length - 1, 1)
        }

        return {
          tree: roots,
          map: tmpList.reduce((map, data) => {
            map[data.id] = data
            return map
          }, {})
        }
      }

      return {
        tree: filterList,
        map: filterList.reduce((map, data) => {
          map[data.id] = data
          return map
        }, {})
      }
    },
    dataTree () {
      return this.filterList.tree
    },
    dataMap () {
      return this.filterList.map
    }
  },
  methods: {
    getRefTable () {
      return this.$refs.table
    },
    getTableSelection () {
      return this.getRefTable().selection
    },
    onDataSelect (selection, row) {
      let table = this.getRefTable()

      this.setTableSelection([...(row.children || [])], selection.indexOf(row) > -1)

      let dataMap = this.dataMap
      let parent = row
      selection = this.getTableSelection()

      while ((parent = dataMap[parent.parentId])) {
        let {children} = parent
        table.toggleRowSelection(parent, children.some(item => selection.indexOf(item) > -1))
      }

      this.onTableSelectionChanged()
    },
    onAllDataSelect (selection) {
      this.setTableSelection([...selection], this.dataTree.some(data => selection.indexOf(data) > -1))
      this.onTableSelectionChanged()
    },
    setTableSelection (selections, isSelected) {
      let table = this.getRefTable()

      for (let i = 0; i < selections.length; i++) {
        let factorData = selections[i]
        let children = factorData.children

        if (children) {
          selections.push(...children)
        }

        table.toggleRowSelection(factorData, isSelected)
      }
    },
    onTableSelectionChanged (flag) {
      let selection = this.getTableSelection()
      let factorIds = selection.filter(data => !Array.isArray(data.children)).map(factorData => factorData.id)
      let auditRuleCategorie = this.$parent.$parent.filterAuditRuleCategories.filter(el => el.isClick)[0]

      let filterFactorIds = []
      if (auditRuleCategorie && auditRuleCategorie.isClick) {
        let factorIdsMap = factorIds.reduce((map, el) => {
          map[el] = el
          return map
        }, {})

        if (auditRuleCategorie.factorIds && auditRuleCategorie.factorIds.length > 0) {
          filterFactorIds = auditRuleCategorie.factorIds.filter(el => factorIdsMap[el])
          if (filterFactorIds.length > 0) {
            this.$eventBus.emit(AUDIT_MAIN_GRID_FACTOR_IDS_CHANGED, Object.freeze(filterFactorIds))
          } else {
            this.$eventBus.emit(AUDIT_MAIN_GRID_FACTOR_IDS_CHANGED, Object.freeze(factorIds))
          }
        }
      } else {
        this.$eventBus.emit(AUDIT_MAIN_GRID_FACTOR_IDS_CHANGED, Object.freeze(factorIds))
      }
      this.$emit('selection-change', factorIds, flag)
    },
    onFilterAuditRuleCategoryIdsChanged () {
      let selection = [...this.getTableSelection()]
      this.setCurrentTableSelection(selection)
    },
    onAuditDataListChanged (selectedFactorIds) {
      let {dataMap} = this
      let selection = selectedFactorIds.map(factorId => dataMap[factorId])
      this.setCurrentTableSelection(selection, false)
    },
    setCurrentTableSelection (selection, flag) {
      this.$nextTick(() => {
        let {dataMap} = this

        selection = selection.filter(({id, children}) => dataMap[id] && !children)
        this.setTableSelection(selection, true)
        let tmpMap = {}
        let tmpList = [...selection]

        for (let i = 0; i < tmpList.length; i++) {
          let parentId = tmpList[i].parentId
          let parent = dataMap[parentId]

          if (!parent) {
            continue
          }

          if (!tmpMap[parentId]) {
            tmpMap[parentId] = parent
            tmpList.push(parent)
          }
        }

        let table = this.getRefTable()

        Object.values(tmpMap).forEach(data => {
          table.toggleRowSelection(data, true)
        })

        this.onTableSelectionChanged(flag)
      })
    },
    onAutoCellNumClick (row, typeId) {
      if (!row.flagMap[typeId]) {
        return
      }

      const flag = Object.entries(this.auditRuleCategoryMap).find(([key, value]) => value === typeId)[0]
      if (!flag) {
        return
      }

      const auditCategoryNameMap = this.auditCategories.reduce((map, auditCategory) => {
        const { name } = auditCategory
        return auditCategory.flags.reduce((map, flag) => {
          map[flag] = name
          return map
        }, map)
      }, {})

      const { children } = row
      const idMap = Array.isArray(children) ? children.reduce((map, row) => {
        map[row.id] = true
        return map
      }, {}) : {
        [row.id]: true
      }

      const {unitProp} = this
      const dataList = this.dataList.reduce((list, data) => {
        const factorId = data.id

        if (idMap[factorId]) {
          const factorName = data.name
          const { decimalNum, displayUnit, stdUnit, molecular } = data
          const dispUnit = data[unitProp]

          if (typeId === 'NULL') {
            const {causeOptionMap, noDataRecordMap} = this
            return data.data.reduce((list, data) => {
              const dataTime = data.dataTime.substr(0, 13)
              const noDataRecord = noDataRecordMap[dataTime]
              if (!data.id) {
                list.push({
                  factorId,
                  factorName,
                  decimalNum,
                  displayUnit,
                  stdUnit,
                  unit: dispUnit,
                  molecular,
                  dataTime,
                  value: data.value,
                  dasFlag: '',
                  autoFlag: '',
                  auditFlag: '数据缺失',
                  auditComment: noDataRecord ? causeOptionMap[noDataRecord] || '' : ''
                })
              }

              return list
            }, list)
          }

          return data.data.reduce((list, data) => {
            const autoFlagList = (data.autoFlag || '').split('|')
            if (autoFlagList.indexOf(flag) > -1) {
              list.push({
                factorId,
                factorName,
                decimalNum,
                displayUnit,
                stdUnit,
                unit: dispUnit,
                molecular,
                dataTime: data.dataTime.substr(0, 13),
                value: Number(unitConverter(data.value, stdUnit, dispUnit, molecular).toFixed(decimalNum)),
                dasFlag: data.dasFlag,
                autoFlag: autoFlagList.reduce((list, flag) => {
                  const flagName = auditCategoryNameMap[flag]
                  if (flagName) {
                    list.push(flagName)
                  }
                  return list
                }, []).join(','),
                auditFlag: auditCategoryNameMap[data.auditFlag],
                auditComment: data.auditComment
              })
            }

            return list
          }, list)
        }

        return list
      }, [])

      this.$emit('onAuditNumClick', dataList, auditCategoryNameMap[flag])
    },
    onManualCellNumClick (row, typeId) {
      if (!row.flagMap[typeId]) {
        return
      }

      const auditCategoryNameMap = this.auditCategories.reduce((map, auditCategory) => {
        const { name } = auditCategory
        return auditCategory.flags.reduce((map, flag) => {
          map[flag] = name
          return map
        }, map)
      }, {})

      const { children } = row
      const idMap = Array.isArray(children) ? children.reduce((map, row) => {
        map[row.id] = true
        return map
      }, {}) : {
        [row.id]: true
      }
      const {unitProp} = this
      const dataList = this.dataList.reduce((list, data) => {
        const factorId = data.id

        if (idMap[factorId]) {
          const factorName = data.name
          const { decimalNum, displayUnit, stdUnit, molecular } = data
          const dispUnit = data[unitProp]

          return data.data.reduce((list, data) => {
            if (data.auditFlag === typeId) {
              const autoFlagList = (data.autoFlag || '').split('|')
              list.push({
                factorId,
                factorName,
                decimalNum,
                displayUnit,
                stdUnit,
                unit: dispUnit,
                molecular,
                dataTime: data.dataTime.substr(0, 13),
                value: Number(unitConverter(data.value, stdUnit, dispUnit, molecular).toFixed(decimalNum)),
                dasFlag: data.dasFlag,
                autoFlag: autoFlagList.reduce((list, flag) => {
                  const flagName = auditCategoryNameMap[flag]
                  if (flagName) {
                    list.push(flagName)
                  } else if (flag === 'N') {
                    list.push('正常')
                  }
                  return list
                }, []).join(','),
                auditFlag: auditCategoryNameMap[data.auditFlag],
                auditComment: data.auditComment
              })
            }

            return list
          }, list)
        }

        return list
      }, [])
      this.$emit('onAuditNumClick', dataList, auditCategoryNameMap[typeId])
    },
    onUnitPropChanged (unitProp) {
      this.unitProp = unitProp
    }
  },
  created () {
    this.$eventBus.on(AUDIT_DATA_LIST_CHANGED, this.onAuditDataListChanged)
    this.$eventBus.on('setCurrentUnitKey', this.onUnitPropChanged)
  },
  beforeDestroy () {
    this.$eventBus.off(AUDIT_DATA_LIST_CHANGED, this.onAuditDataListChanged)
    this.$eventBus.off('setCurrentUnitKey', this.onUnitPropChanged)
  }
}
</script>

<style lang="scss">
.audit-table {
  .custom-table-header {
    &:first-child {
      th {
        &:nth-child(2),
        &:nth-child(3) {
          border-right: 1px solid #EBEEF5 !important;
        }

        &:nth-child(3),
        &:nth-child(4) {
          border-bottom: 1px solid #EBEEF5 !important;
        }
      }
    }

    &:nth-child(2) {
      th {
        &:nth-child(9) {
          border-right: 1px solid #EBEEF5 !important;
        }
      }
    }

    .cell {
      white-space: nowrap;
    }
  }
}
</style>

<style lang="scss" scoped>
.RESERVE {
  &:not([value="0"]) {
    color: #67c23a;
    cursor: pointer;
  }
}

.DELETE {
  &:not([value="0"]) {
    color: #f56c6c;
    cursor: pointer;
  }
}

.exception {
  &:not([value="0"]) {
    color: #e6a23c;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/AuditMainGrid.vue